import React from 'react';
import { TrendingUp, Target, Users, Eye, Activity } from 'lucide-react';
import { MiniMetric } from './HomeMicroComponents';
import WavePulseGauge from '../metrics/WavePulseGauge';
import { MetricExplainerIcon } from '../metrics/MetricWithExplainer';

export default function PerformanceColumn({ liveMetrics }) {
  // Brand Pulse — lifetime average across every wave the brand has run.
  // When real data lands we'll read it from the live state; for the
  // pre-wave home view we use the same fixed-but-realistic baseline.
  const brandPulse = 87;

  return (
    <div className="rounded-2xl p-5 lg:p-6" style={{ background: '#242730', border: '1px solid #2E3240' }}
         data-testid="performance-column">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="flex items-center gap-1">
            <p className="text-[9px] uppercase tracking-widest text-gray-500 font-bold mb-0.5">Brand Pulse · lifetime</p>
            <MetricExplainerIcon metric="brand_pulse" placement="bottom" />
          </div>
          <h2 className="text-base font-black text-white">Performance at a Glance</h2>
        </div>
        <span className="text-[8px] px-2 py-1 rounded-full bg-[#00D4FF]/10 text-[#00D4FF] border border-[#00D4FF]/20 font-bold">
          Top 8% this month
        </span>
      </div>

      <div className="flex items-center gap-5 mb-4">
        <WavePulseGauge score={brandPulse} size="md" dense />
        <div className="flex-1 space-y-2">
          <div className="grid grid-cols-2 gap-2">
            <MiniMetric label="ROAS"        value="4.2×" color="#00D4FF"  icon={Target}      metric="roas" />
            <MiniMetric label="Eng Rate"    value="6.8%" color="#FF4D94"  icon={TrendingUp}  metric="engagement_rate" />
          </div>
          <div className="rounded-lg px-3 py-2.5 flex items-center justify-between" style={{ background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.25)' }}>
            <div>
              <p className="text-[9px] text-gray-400 uppercase tracking-wider font-bold">Last Wave ROI</p>
              <p className="text-xl font-black text-green-400 tabular-nums">$60K earned</p>
            </div>
            <TrendingUp className="h-5 w-5 text-green-400" />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 pt-3 border-t border-[#2E3240]">
        <div className="rounded-lg p-3" style={{ background: '#181A20' }} data-testid="creators-stat">
          <div className="flex items-center justify-between mb-1">
            <Users className="h-3.5 w-3.5 text-[#FF4D94]" />
            <span className="text-[8px] px-1.5 py-0.5 rounded-full bg-[#FF4D94]/15 text-[#FF4D94] font-bold">Hot Streak</span>
          </div>
          <p className="text-lg font-black text-white tabular-nums">
            {liveMetrics ? liveMetrics.totalCreators.toLocaleString() : '29'} Creators
          </p>
          <p className="text-[9px] text-gray-500">
            {liveMetrics ? `${liveMetrics.activeCampaigns} active campaign${liveMetrics.activeCampaigns !== 1 ? 's' : ''}` : '2 active campaigns'} · Activated
          </p>
        </div>
        <div className="rounded-lg p-3" style={{ background: '#181A20' }} data-testid="impressions-stat">
          <div className="flex items-center justify-between mb-1">
            <Eye className="h-3.5 w-3.5 text-[#00D4FF]" />
            <span className="text-[8px] px-1.5 py-0.5 rounded-full bg-[#00D4FF]/15 text-[#00D4FF] font-bold">+2.4× industry</span>
          </div>
          <p className="text-lg font-black text-white tabular-nums">42.3M Impressions</p>
          <p className="text-[9px] text-gray-500">This month · Micro-creator network</p>
        </div>
      </div>
    </div>
  );
}
